/**
 * 骨架屏组件
 * 用于数据加载时显示占位效果
 */

interface SkeletonProps {
  className?: string;
  style?: React.CSSProperties;
}

export function Skeleton({ className = "", style }: SkeletonProps) {
  return (
    <div
      className={`animate-pulse bg-slate-200 dark:bg-[#1a1d1f] rounded ${className}`}
      style={style}
    />
  );
}

/**
 * 卡片骨架屏
 */
export function CardSkeleton() {
  return (
    <div className="bg-slate-50 dark:bg-[#1a1d1f] rounded-2xl border border-slate-200 dark:border-slate-800 p-6 space-y-4">
      <Skeleton className="h-6 w-3/4" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-5/6" />
      <div className="pt-4 space-y-2">
        <Skeleton className="h-10 w-full" />
      </div>
    </div>
  );
}

/**
 * 充值计划卡片骨架屏
 */
export function PlanCardSkeleton() {
  return (
    <div className="relative flex flex-col p-6 bg-slate-50 dark:bg-[#1a1d1f] rounded-2xl border border-slate-200 dark:border-slate-800">
      {/* 标题区域 */}
      <div className="mb-5">
        <div className="flex justify-between items-start">
          <Skeleton className="h-7 w-32" />
          <Skeleton className="h-5 w-5 rounded-full" />
        </div>
        <Skeleton className="h-4 w-full mt-2" />
      </div>

      {/* 价格区域 */}
      <div className="mb-5">
        <div className="flex items-baseline gap-2">
          <Skeleton className="h-9 w-20" />
          <Skeleton className="h-4 w-12" />
        </div>
        <Skeleton className="h-14 w-full mt-4 rounded-xl" />
      </div>

      {/* 特性列表 */}
      <div className="space-y-3 mb-6">
        {[1, 2, 3].map((i) => (
          <div key={i} className="flex items-start gap-3">
            <Skeleton className="h-4 w-4 rounded-full shrink-0" />
            <Skeleton className="h-4 w-full" />
          </div>
        ))}
      </div>

      {/* 按钮 */}
      <Skeleton className="h-12 w-full rounded-full" />
    </div>
  );
}

/**
 * 表格行骨架屏
 */
export function TableRowSkeleton({ cols = 3 }: { cols?: number }) {
  return (
    <tr className="hover:bg-white dark:hover:bg-[#D2F0E1]/5 transition-colors">
      {Array.from({ length: cols }).map((_, i) => (
        <td key={i} className="py-4 whitespace-nowrap">
          <Skeleton className="h-4 w-24" />
        </td>
      ))}
    </tr>
  );
}

/**
 * 图表骨架屏
 */
export function ChartSkeleton() {
  return (
    <div className="bg-slate-50 dark:bg-[#1a1d1f] rounded-2xl border border-slate-200 dark:border-slate-800 p-6">
      <div className="flex items-center justify-between mb-8">
        <Skeleton className="h-6 w-32" />
        <Skeleton className="h-6 w-24 rounded-full" />
      </div>
      <div className="h-[230px] flex items-end justify-around gap-2 px-4">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="flex-1 flex flex-col items-center gap-2">
            <Skeleton className="w-full" style={{ height: `${Math.random() * 150 + 50}px` }} />
            <Skeleton className="h-3 w-16" />
          </div>
        ))}
      </div>
    </div>
  );
}
